import styled from "styled-components";
import FlexBox from "components/layouts/FlexBox/FlexBox";
import { Form } from "components";
import RadioGroup from "components/forms/RadioGroup/RadioGroup";

export const StyledForm = styled(Form)`
  background: transparent;
  padding: 0;

  /*
   * VDS Input/Select/TextArea all render their label through the shared
   * form-elements Label as <label data-testid="test-label"><p>…</p></label>,
   * styled as Body size="small" (12px Verizon-NHG-eTX) regular #000000.
   * The design puts field labels on the same treatment as this form's
   * radio/checkbox prompts (Body size="small" bold color="#6f7171"), so size
   * and family already match — only weight and color need overriding.
   */
  label[data-testid="test-label"] > p {
    font-weight: 700;
    color: #6f7171;
  }
`;

/*
 * The shared RadioGroup wrapper downsizes VDS RadioButton option labels to
 * 12px; this form's design uses the VDS default 16px. Scoped to this feature
 * so accessModal/search RadioGroups keep their existing sizing.
 */
export const StyledRadioGroup = styled(RadioGroup)`
  && label > div > span {
    font-size: 1rem;
    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
    letter-spacing: 0.5px;
  }
`;

export const StyledSection = styled(FlexBox)`
  padding: 1.5rem 0;
`;

export const DragWrapper = styled.div`
  background-color: #ffffff;
  border: 1px dashed #747676;
  border-radius: 0.5rem;
  overflow: hidden;

  /*
   * DragAndDrop renders its own solid-bordered box; neutralize it so only
   * this wrapper's dashed border shows (avoids a double border).
   */
  & > div > div:first-child {
    border: none;
    border-radius: 0;
  }
`;

export const SuccessPanel = styled(FlexBox)`
  background: #f6f6f6;
  border-radius: 0.5rem;
  padding: 2rem;
  align-items: flex-start;
`;

export const ChecklistWrapper = styled.div`
  ul {
    margin: 0.25rem 0 0;
    padding-left: 1.25rem;
  }
  li {
    margin-bottom: 0.25rem;
  }
`;

/*
 * Groups the upload-help email text with the drag-and-drop zone so the parent
 * StyledSection's 1.25rem gap doesn't apply between them — just this pair sits
 * tighter, without changing spacing between the section's other children.
 */
export const UploadHelpGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

/*
 * Keeps anchor links (e.g. the upload-help mailto) black instead of default
 * link blue/purple — including visited/hover — while preserving the underline.
 */
export const BlackLinkWrapper = styled.div`
  a,
  a:visited,
  a:hover,
  a:active {
    color: #000000;
    text-decoration: underline;
  }
`;

/* ─── Per-file upload row (Asset Type per file) ───────────────────────── */

export const FileRowWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
`;

export const FileCard = styled.div`
  position: relative;
  flex: 2;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  background-color: #f6f6f6;
  border-radius: 0.5rem;
  padding: 0.75rem 2.5rem 0.75rem 0.75rem;
`;

export const ThumbnailWrapper = styled.div`
  flex: 0 0 auto;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 0.25rem;
  background-color: #ffffff;
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const FileNameWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  text-align: center;
`;

export const FileNameText = styled.div`
  width: 100%;

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const RemoveButtonWrapper = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
`;

export const SelectColumn = styled.div`
  flex: 1;
`;
